module.exports = __webpack_public_path__ + "static/media/studio_electric_forklift_truck_me_320_manitou_001.784f64a8.png";